import { request } from '../../xhr';
import { call, put, all, takeEvery, delay } from 'redux-saga/effects';
import { normalize } from '../../redux/normalizr';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { actions as ModalActions } from '../../Modals';
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { createPollRequest as createPollRequestAction, updatePollRequest as updatePollRequestAction, createPollSuccess as createPollSuccessAction, updatePollSuccess as updatePollSuccessAction, requestFailure } from './actions';
import { actions as notificationActions, NotificationType } from '../../Notifications';
import ErrorIcon from '@wix/da-ds/pkg/Icons/24x24/Error';
import { editDeviationSuccess } from '../../redux/deviations/actionCreators';
import { logBiEvent } from '../../biLogger/redux/saga';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { ResourceType } from '../../types/resource';
function* postRequest(url, data) {
    return yield call(request, {
        method: 'post',
        url,
        data
    });
}
export function* createPollRequestSaga(action) {
    const payload = action.payload;
    const params = {
        question: payload.question,
        answers: payload.answers
    };
    const response = yield call(postRequest, '/poll/create', params);
    if (response && response.deviation) {
        const normalizedDeviation = normalize(response.deviation, deviationSchema);
        yield all([
            call(logBiEvent, PureBiData({
                evid: 11,
                group_exclusive: false,
                typeid: ResourceType.POLL_BLOG,
                itemid: response.deviation.deviationId
            })),
            put(createPollSuccessAction(normalizedDeviation)),
            put(ModalActions.popModal())
        ]);
        yield delay(400);
        if (payload.refreshAfterSubmit) {
            window.location.reload();
        } else {
            window.location.assign(getDeviationUrl(response.deviation));
        }
    } else {
        if (response && response.errorCode === 302) {
            window.location.replace(response.errorDetails.redirectUrl);
        }
        yield all([
            put(notificationActions.addNotification(NotificationType.Generic, {
                messageLocaleKey: 'common.somethingWentWrong',
                cardProps: {
                    iconComponent: ErrorIcon
                }
            })),
            put(requestFailure())
        ]);
    }
}
export function* updatePollRequestSaga(action) {
    const payload = action.payload;
    const params = {
        pollid: payload.pollId,
        question: payload.question,
        answers: payload.answers
    };
    const response = yield call(postRequest, '/poll/update', params);
    if (response && response.deviation) {
        const normalizedDeviation = normalize(response.deviation, deviationSchema);
        yield all([
            put(updatePollSuccessAction(normalizedDeviation)),
            put(editDeviationSuccess({
                deviation: response.deviation
            })),
            put(ModalActions.popModal())
        ]);
    } else {
        yield all([
            put(notificationActions.addNotification(NotificationType.Generic, {
                messageLocaleKey: 'common.somethingWentWrong',
                cardProps: {
                    iconComponent: ErrorIcon
                }
            })),
            put(requestFailure())
        ]);
    }
}
export default function* pollsSagas() {
    yield all([
        takeEvery(updatePollRequestAction, updatePollRequestSaga),
        takeEvery(createPollRequestAction, createPollRequestSaga)
    ]);
}
